var colours = {
  black: '#141414',
  error100: '#cc1426',
  grey5: '#f3f3f3',
  grey15: '#d8d8d8',
  grey50: '#7f7f7f',
  grey83: '#2b2b2b',
  white: '#fff'
};
var fontSize = '16px';
var fontWeight = '400';
var appearance = {
  theme: 'flat',
  variables: {
    accessibleColorOnColorPrimary: colours.grey83,
    accordionItemSpacing: '8px',
    borderRadius: '0',
    colorBackground: colours.white,
    fontFamily: '"GillSansforJL", "Gill Sans", "Gill Sans MT", "GillSansMTStd-Medium", Avenir, Corbel, Arial, Helvetica, sans-serif',
    fontLineHeight: '1.5'
  },
  rules: {
    '.Block': {
      boxShadow: 'none',
      padding: '12px'
    },
    '.AccordionItem': {
      border: "1px solid ".concat(colours.grey15),
      fontSize: fontSize,
      fontWeight: fontWeight,
      padding: '20px 20px 16px 20px'
    },
    '.AccordionItem--selected': {
      borderColor: colours.black,
      color: colours.black
    },
    '.Error': {
      fontSize: fontSize,
      fontWeight: fontWeight,
      marginTop: '8px'
    },
    '.Label': {
      color: colours.black,
      fontSize: fontSize,
      fontWeight: fontWeight,
      lineHeight: '22px',
      marginBottom: '8px'
    },
    '.Input': {
      border: "1px solid ".concat(colours.grey50),
      borderRadius: '2px',
      boxShadow: 'none',
      padding: '14px 12px'
    },
    '.Input:focus': {
      boxShadow: "inset 0 0 0 1px ".concat(colours.black),
      outline: 'none'
    },
    '.Input:focus, .Input:hover': {
      borderColor: colours.black,
      borderRadius: '4px',
      borderWidth: '1px'
    },
    '.Input--invalid, .Input--invalid:focus, .Input--invalid:hover': {
      borderColor: colours.error100,
      borderWidth: '1px',
      boxShadow: 'none'
    },
    '.Input:disabled, .Input--invalid:disabled': {
      color: colours.grey5
    }
  }
};
var currency = 'gbp';
var stripeOptions = function stripeOptions(_ref) {
  var amount = _ref.amount;
  return {
    allowedCardBrands: ['visa', 'mastercard', 'american_express'],
    loader: 'never',
    mode: 'payment',
    paymentMethodCreation: 'manual',
    paymentMethodTypes: ['card'],
    appearance: appearance,
    amount: amount,
    currency: currency
  };
};
export { stripeOptions };